export default __webpack_public_path__ + "static/media/ball_green_black.fc4b5158.svg";